import { loadScript } from 'src/frontend-lib/tools/loadScript.js'
import { GetQueryString } from 'src/frontend-lib/tools/utils.js'

class Mp {
  _loadWxForMp() {
    if (this.loadUniScript) return this.loadUniScript
    const userAgent = navigator.userAgent
    let thirdJs = ''
    if (userAgent.indexOf('AlipayClient') > -1) {
      // 支付宝小程序的 JS-SDK 防止 404 需要动态加载，如果不需要兼容支付宝小程序，则无需引用此 JS 文件。
      thirdJs = `https://appx/web-view.min.js`
    } else if (/QQ/i.test(userAgent) && /miniProgram/i.test(userAgent)) {
      // QQ 小程序
      thirdJs = `https://qqq.gtimg.cn/miniprogram/webview_jssdk/qqjssdk-1.0.0.js`
    } else if (/miniProgram/i.test(userAgent)) {
      // 微信小程序 JS-SDK 如果不需要兼容微信小程序，则无需引用此 JS 文件。
      thirdJs = `https://res.wx.qq.com/open/js/jweixin-1.6.0.js`
    } else if (/toutiaomicroapp/i.test(userAgent)) {
      // 头条小程序 JS-SDK 如果不需要兼容头条小程序，则无需引用此 JS
      thirdJs = `https://s3.pstatp.com/toutiao/tmajssdk/jssdk-1.0.1.js`
    } else if (/swan/i.test(userAgent)) {
      // 百度小程序 JS-SDK 如果不需要兼容百度小程序，则无需引用此 JS 文件。
      thirdJs = `https://b.bdstatic.com/searchbox/icms/searchbox/js/swan-2.0.18.js`
    }
    const uniJs = `https://js.cdn.aliyun.dcloud.net.cn/dev/uni-app/uni.webview.1.5.2.js`
    this.loadUniScript = loadScript(thirdJs).then(() => loadScript(uniJs))

    return this.loadUniScript
  }

  openWebView(options = {}) {
    let { isCurrentPageOpen, url, ...otherOptions } = options
    this._loadWxForMp().then(() => {
      if (typeof isCurrentPageOpen === 'undefined') {
        isCurrentPageOpen = 0
      }
      const event = isCurrentPageOpen === 0 ? 'navigateTo' : 'redirectTo'
      window.uni[event]({
        ...otherOptions,
        url:
          url.indexOf('http://') > -1 ||
          url.indexOf('https://') > -1 ||
          url.startsWith('//')
            ? '../webView/webView?src=' + encodeURIComponent(url)
            : url
      })
    })
  }

  cancelWebView(options = {}) {
    this._loadWxForMp().then(() => {
      window.uni.navigateBack(options)
    })
  }

  postMessage(data) {
    this._loadWxForMp().then(() => {
      window.uni.postMessage({ data })
    })
  }

  callApi(apiName, options = {}, isCurrentPageOpen = 0) {
    this._loadWxForMp().then(() => {
      const { tips = '', btnText = '' } = options
      const allOptions = {
        apiName,
        ...options
      }

      const event = isCurrentPageOpen === 0 ? 'navigateTo' : 'redirectTo'

      window.uni[event]({
        url:
          '../callApi/callApi?data=' +
          encodeURIComponent(JSON.stringify(allOptions)) +
          '&tips=' +
          tips +
          '&btnText=' +
          btnText
      }).join('&')
    })
  }
}

const userAgent = navigator.userAgent
Mp.isToutiaoMp = /ToutiaoMicroApp/i.test(userAgent)
Mp.isAliPayMp = +GetQueryString('isAliPay') === 1
Mp.isMp = /miniProgram/i.test(userAgent) || Mp.isToutiaoMp || Mp.isAliPayMp
Mp.isWebviewMp = Mp.isMp && GetQueryString('isWebviewMp', window.location.href)

export default Mp



// WEBPACK FOOTER //
// ./src/public-resource/libs/utils/mp.js